<template>
  <v-app>
    <v-toolbar app>
      <v-btn flat disabled fab>
        <v-img :src="require('./assets/logo.png')"></v-img>
      </v-btn>
      <v-toolbar-title class="headline text-uppercase">
        <v-btn flat large to="/">Play</v-btn>
        <v-btn flat large to="/about"><span class="font-weight-light">About</span></v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <h1 class="display-2 text-xs-center pt-3">Minesweeper</h1>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data () {
    return {
      //
    }
  }
}
</script>
